export default __webpack_public_path__ + "static/ivyblogo-db3b21f816c3e60db4ec6528331c75b4.png";